import { FacebookRounded, Instagram, LinkedIn, X } from "@mui/icons-material";
import { newFooterLinks } from "./constants";
import { Link } from "react-router-dom";
import { Footer_Bg } from "../images";

export const NewFooter = ({children}) => {
  return (
    <div
      className="bg-left-bottom md:bg-center bg-cover md:bg-cover"
      style={{
        backgroundImage: `url("${Footer_Bg}")`,
      }}
    >
      <div className="container pb-6 pt-6 md:pt-11 md:pb-20 space-y-14">
        {children}

        <footer className="w-full flex flex-col justify-between items-center gap-6 py-10 md:py-14 rounded-xl">
          <div className="w-full flex flex-col md:flex-row md:flex-wrap gap-16 md:gap-3 justify-between items-center md:items-start border-b border-[#FFFFFF36] pb-12">
            {newFooterLinks.map((footer) => (
              <div
                key={footer.label}
                className="flex flex-col items-center md:items-start gap-[12px]"
              >
                <h1 className="text-base font-bold text-white">
                  {footer.label}
                </h1>
                <div className="flex flex-col items-center md:items-start gap-3">
                  {footer.links.map((f, idx) =>
                    f.link.includes("#") ||
                    f.link.includes("mailto") ||
                    f.link.includes("https") ||
                    f.external ? (
                      <a
                        href={f.link}
                        key={`${f.label}-${idx}`}
                        target="_blank"
                        without rel="noreferrer"
                        className="text-sm text-[#C0C0C0] hover:text-white duration-150 ease-in"
                      >
                        {f.label}
                      </a>
                    ) : (
                      <Link
                        to={f.link}
                        key={f.label}
                        className="text-sm text-[#C0C0C0] hover:text-white duration-150 ease-in"
                      >
                        {f.label}
                      </Link>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="w-full flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/analytics-intelligence/"
                target="_blank"
                rel="noreferrer"
                title="linkedin"
              >
                <LinkedIn className="text-white" />
              </a>
              <a
                href="https://www.instagram.com/analyticsintelligence/"
                target="_blank"
                rel="noreferrer"
                title="instagram"
              >
                <Instagram className="text-white" />
              </a>
              <a
                href="https://www.facebook.com/Analyticsintel/"
                target="_blank"
                rel="noreferrer"
                title="facebook"
              >
                <FacebookRounded className="text-white" />
              </a>
              <a
                href="https://twitter.com/_AnalyticsIntel"
                target="_blank"
                rel="noreferrer"
                title="X"
              >
                <X className="text-white" />
              </a>
            </div>
            <p className="text-xs text-[#FFFFFF80] text-center">
              Copyright {new Date().getFullYear()} [AI] Analytics Intelligence
              Inc. All Rights Reserved
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};
